import Button from "@/common/components/Button";
import { Sheet, SheetClose, SheetContent, SheetTitle, SheetTrigger } from "@/common/components/ui/sheet";
import { ChevronRightIcon, FilterIcon } from "lucide-react";
import { createElement, Dispatch, SetStateAction, useCallback } from "react";
import { DateRange } from "react-day-picker";
import { dashboardFiltersSheetComponents } from "../../constants/dashboards/dashboardFilters.constant";
import { DashboardFilters } from "../../types/dashboards/dashboard.type";
import { DashboardComponentFiltersParams } from "../../types/dashboards/dashboardComponent.type";

interface DashboardSheetFiltersProps {
  filters: DashboardComponentFiltersParams & {
    date: DateRange | undefined;
  };
  setFilters: Dispatch<SetStateAction<DashboardComponentFiltersParams & {
    date: DateRange | undefined;
  }>>;
  dashboardDesiredFilters: DashboardFilters[];
  width: number;
}

const DashboardSheetFilters = ({
  filters,
  setFilters,
  dashboardDesiredFilters,
  width,
}: DashboardSheetFiltersProps) => {
  const renderFilters = useCallback((desiredFilter: DashboardFilters) => {
    const Component = dashboardFiltersSheetComponents[desiredFilter];

    if (!Component)
      return null;

    return createElement(Component, {
      key: desiredFilter,
      filters: filters,
      setFilters: setFilters,
    });
  }, [filters, setFilters]);

  if (!dashboardDesiredFilters.length) {
    return null;
  }

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button className="flex h-8 gap-x-2 items-center font-light text-xs italic rounded-xl text-nowrap bg-blue-200 text-white-800 hover:bg-blue-300">
          {width && width > 580 && 'Ver todos'}

          <FilterIcon className="size-4" />
        </Button>
      </SheetTrigger>

      <SheetContent className="w-72 bg-black-300 text-white-800 border-none backdrop-blur-3xl p-0" showClose={false}>
        <div className="flex items-center gap-x-2 mx-4 my-8">
          <SheetClose asChild>
            <Button variant="outline-text" className="flex items-center justify-center size-8 p-0">
              <ChevronRightIcon className="size-8" strokeWidth={1.33} />
            </Button>
          </SheetClose>

          <SheetTitle className="font-bold text-xl">
            Filtro
          </SheetTitle>
        </div>

        <div className="overflow-y-auto no-scrollbar max-h-[calc(100vh-96px)]">
          {dashboardDesiredFilters?.map(renderFilters)}
        </div>
      </SheetContent>
    </Sheet>
  );
}

export default DashboardSheetFilters;
